<template>
    <div>
        <breadCrumb 
            :icon="''"
            :category="$t(`sideNav.navMySalon`)"
            :subCategory="$t(`subMenu.my_salon_tukang`)"
            :subSubCategory="''">
        </breadCrumb>
        <ul  class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
            <li class="nav-item" v-for="t in $i18n.messages[$i18n.locale].tab.tukangTabs" :key="t.id">
                <a class="nav-link bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="selectedTab = t.id">{{t.text}}</a>
            </li>
        </ul>
        <div class="px-3 px-sm-5 py-4">
            <div class="tab-content">
                <tukangShop :class="{'active': selectedTab == 'shop'}" class="tab-pane" :cityList="cityList"></tukangShop>
                <tukangStaff :class="{'active': selectedTab == 'staff'}" class="tab-pane" :cityList="cityList"></tukangStaff>
                <tukangPost v-if="category.length != 0" class="tab-pane" :class="{'active': selectedTab == 'post'}" :category="category"></tukangPost>
                <tukangOrder :class="{'active': selectedTab == 'order'}" class="tab-pane"></tukangOrder>
            </div>
        </div>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import TukangPost from './Tukang_Post'
import TukangShop from './Tukang_Shop'
import TukangStaff from './Tukang_Staff'
import TukangOrder from './Tukang_Order'
import {getCityList, handleSessionExpired} from '@/assets/js/dashboard/dashboard.js'
export default {
    name: "menuTukang",
    components:{
        TukangShop, TukangStaff, TukangPost, TukangOrder, BreadCrumb
    },
    data(){
        return{
            selectedTab: "post",
            cityList: [],
            category:[]
        }
    },
    methods:{
        async getCategory(){
            let $vm = this;
            var res = []
            await $vm.$axios({
                method: 'get', 
                url: $vm.$api.TUKANG_CATEGORY,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                var result = response.data.result
                for(var i=0; i<result.length; i++){
                    res.push({
                        id: result[i].categoryID,
                        text: result[i].category, 
                    })
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return res
        }
    },
    async mounted(){
        let $vm = this;
        $vm.cityList = await getCityList($vm);
        $vm.category = await $vm.getCategory()
    },
}
</script>
<style scoped>
.img-social{
    width: 1.5em;
    border: 2px solid #f3f3f3;
    border-radius: 8px;
}
.nav-link{
    cursor: pointer;
}
</style>